import { render, staticRenderFns } from "./CommentCreatingBlock.vue?vue&type=template&id=562ddc68&scoped=true&"
import script from "./CommentCreatingBlock.vue?vue&type=script&lang=js&"
export * from "./CommentCreatingBlock.vue?vue&type=script&lang=js&"
import style0 from "./CommentCreatingBlock.vue?vue&type=style&index=0&id=562ddc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ddc68",
  null
  
)

export default component.exports